export default {
    infoAboutService: 'Informace o servisu',
    infoAboutParkingArea: 'Adresa odstavné plochy',

    openingHours: 'Otevírací doba',
    openingHoursWeek: 'Po - Pá',
    openingHoursSaturday: 'So',
    openingHoursSunday: 'Ne',
    openingHoursNote: 'Aktuální otevírací dobu si prosím ověřte na webu servisu.',

    contact: 'Kontakt',
    contactEmail: 'E-mail',
    contactPhone: 'Telefon',
    operator: 'Provozovatel',

    infoAboutChargingStation: 'Informace o nabíjecí stanici',
    imageSource: 'Zdroj',
    buttonCopyAddress: 'Zkopírovat adresu',
    buttonCopyGps: 'Zkopírovat GPS',
    tooltipCopied: 'Zkopírováno',
    recommendedCard: 'Doporučená karta',
    recommendedCardProviderInfo: 'a jejich akceptační síť',
    recommendedCardProviderInfoUpTo: 'do',
    recommendedCardProviderInfoHigherPower: 'vyšší výkon',
    recommendedCardModalTitle: 'Doporučená nabíjecí karta',
    recommendedCardModalDescription: 'Řidiči vozidel Drivalia dostávají dvě karty, které zajistí co nejširší pokrytí, a zároveň výhodné ceny. V náhledu stanice vám doporučíme, kterou kartu je nejvýhodnější použít.<br /><br />Název karty najdete v jejím levém horním rohu.',
    stationIdentification: 'ID stanice',
    stationUnderConstruction: 'Na tuto stanici se můžete těšit, aktuálně je ve výstavbě.',
    stationAdditionalInformation: 'V případě nefunkčního nabíjení volejte nejdříve na telefonní číslo uvedené na nabíjecí stanici. V ostatních případech je vám k dispozici linka řidičů <a href="tel:+420296333666">+420 296 333 666</a>.',

    connectors: 'Konektory',

    additionalServices: 'Doplňkové služby',
    additionalServicesFree: 'zdarma',
    additionalServicesNotAgreed: 'služba není sjednaná',
    additionalServicesPickUp: 'Pick-Up',
    additionalServicesReplacementVehicle: 'Náhradní vozidlo',
    additionalServicesCarWash: 'Mytí exteriéru vozu',

    additionalServicesPickupNote: 'Služba Pick-up je zdarma pouze do vzdálenosti 20 km.',
    additionalServicesReplacementVehicleNote: 'Náhradní vozidlo je zdarma po dobu servisu, maximálně však na 1 den.',
    additionalServicesCarWashNote: 'Služba mytí zdarma obsahuje jen základní mytí exteriéru a luxování interiéru.',
    additionalServicesChargeNote: 'Služba je zpoplatněná, pokud není uvedeno jinak.',

    orderToServiceButton: 'Objednat se do servisu',
    orderReturnWithInspector: 'Objednat vrácení s inspektorem',
    navigateToServiceButton: 'Navigovat do servisu',
    navigateToChargingStationButton: 'Navigovat k nabíjecí stanici',

    errorMessageNotFound: 'Servis nebyl nazelezen.',
    errorMessageChargingStationNotFound: 'Nabíjecí stanice nebyla nalezena.'
}
